'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    save: 'Сохранить',
    send: 'Отправить',
    next: 'Вперед',
    prev: 'Назад',
    required: 'Это поле обязательно для заполнения',
    minLengthField: 'Недостаточно символов',
    incorrectEmail: 'Некорректный формат email',
    incorrectDate: 'Некорректный формат даты',
    month: 'Месяц',
    monthYearError: 'Месяц и год обязательны для заполнения',
    yearError: 'Год обязателен для заполнения',
    monthError: 'Месяц обязателен для заполнения',
    dayError: 'День обязателен для заполнения',
    dayYearError: 'День и год обязательны для заполнения',
    dayMonthError: 'День и месяц обязательны для заполнения',
    empty: 'Нет данных',
    add: 'Добавить',
    delete: 'Удалить',
    cancel: 'Отмена',
    workExperience: 'Стаж в должности',
    age: 'Возраст',
    selectDate: 'Выбрать дату',
    selectMonth: 'Выберите месяц',
    minLength: '\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D, \u043F\u043E\u0442\u043E\u043C\u0443 \u0447\u0442\u043E \u043D\u0435 \u0432\u0432\u0435\u0434\u0435\u043D\u043E \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0437\u043D\u0430\u043A\u043E\u0432!\n\u041C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0437\u043D\u0430\u043A\u043E\u0432: {minLength}\n\u0417\u043D\u0430\u043A\u043E\u0432 \u0432\u0432\u0435\u0434\u0435\u043D\u043E: {length}',
    minLengthText: '\u0417\u043D\u0430\u043A\u043E\u0432 \u0432 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0435: {length} \u0438\u0437 {minLength}',
    lengthText: '\u0421\u0438\u043C\u0432\u043E\u043B\u043E\u0432 \u0432 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0435, \u0432\u043A\u043B\u044E\u0447\u0430\u044F \u043F\u0440\u0435\u0434\u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u043D\u044B\u0435 \u043F\u043E\u043B\u044F: {length}',
    workloadText: '\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u0431\u0443\u0434\u0435\u0442 \u0443\u0447\u0442\u0451\u043D \u0432 \u043E\u0442\u0447\u0435\u0442\u0435 Workload',
    noWorkloadText: '\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442  \u043D\u0435 \u0431\u0443\u0434\u0435\u0442 \u0443\u0447\u0442\u0451\u043D \u0432 \u043E\u0442\u0447\u0451\u0442\u0435 Workload',
    workloadMinText: '\u041C\u0438\u043D. \u043A\u043E\u043B. \u0437\u043D\u0430\u043A\u043E\u0432 \u0434\u043B\u044F Workload: {minLength}, \u043E\u0434\u043D\u0430\u043A\u043E \u0441\u043E\u0433\u043B\u0430\u0441\u043D\u043E \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430\u043C \u0444\u043E\u0440\u043C\u044B \u043D\u0438 \u043E\u0434\u0438\u043D \u0432\u043E\u043F\u0440\u043E\u0441 \u043D\u0435 \u0443\u0447\u0438\u0442\u044B\u0432\u0430\u0435\u0442\u0441\u044F \u0432 Workload',
    workloadCurrentLengthText: '\u0412\u043D\u0435\u0441\u0435\u043D\u043E \u0434\u043B\u044F Workload: {length} \u0438\u0437 {minLength}',
    deleteConfirm: 'Данные, удаляемые/изменяемые в документе, также будут удалены/изменены в карточке Experium.',
    deleteDescription: 'Вы уверены, что хотите удалить их в документе и в карточке?',
    deleteOk: 'Да',
    deleteCancel: 'Нет',
    selectInput: 'Выбор в БД',
    addBlockTop: 'Добавить сверху',
    addBlockBottom: 'Добавить снизу'
};